import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PublicCustomer } from 'src/sb-modules/Frontend-form-field-module/common/models/public-customer.model';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '@environment';

@Injectable({
    providedIn: 'root',
})
export class ConfigurationService {
    constructor(private httpClient: HttpClient) {}

    get(): Observable<PublicCustomer> {
        return this.httpClient.get<PublicCustomer>(environment.apiMasterUrl + 'customer/');
    }
}
